export default __webpack_public_path__ + "2d72b526e069697440185124fa875bdd.svg";